import { useCallback } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import StoryDetailHeader from '../components/stories/StoryDetailHeader'
import StoryArticleBody from '../components/stories/StoryArticleBody'
import StoryRelatedStories from '../components/stories/StoryRelatedStories'
import { getStoryBySlug } from '../data/storiesContent'
import { programSectionGap } from '../components/programs/programLayout'
import { mobilePaddingX, mobileSectionPy, mobileTitleToContentGap } from '../theme/mobileLayout'

const sectionWrapperSx = {
  width: '100%',
  maxWidth: 1920,
  mx: 'auto',
  px: mobilePaddingX,
  boxSizing: 'border-box',
}

export default function StoryDetailPage() {
  const { slug } = useParams()
  const story = getStoryBySlug(slug)

  const handleShare = useCallback(async () => {
    const url = window.location.href
    const shareData = {
      title: story?.title,
      text: story?.title,
      url,
    }

    if (navigator.share) {
      try {
        await navigator.share(shareData)
        return
      } catch {
        // User cancelled or share failed — fall through to clipboard.
      }
    }

    try {
      await navigator.clipboard.writeText(url)
    } catch {
      // Clipboard unavailable.
    }
  }, [story?.title])

  if (!story) {
    return <Navigate to="/stories" replace />
  }

  return (
    <Box>
      <Box
        sx={{
          ...sectionWrapperSx,
          pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
          pb: { xs: 6, md: 8, lg: 0 },
        }}
      >
        <Box sx={{ maxWidth: 1520, mx: 'auto' }}>
          <StoryDetailHeader date={story.date} title={story.title} onShare={handleShare} />

          <Box
            sx={{
              mt: mobileTitleToContentGap,
              width: '100%',
              height: { xs: 240, sm: 360, md: 500, lg: 800 },
              borderRadius: '20px',
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={story.heroImage}
              alt={story.title}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
              }}
            />
          </Box>

          <Box
            sx={{
              mt: mobileTitleToContentGap,
              maxWidth: 1200,
              mx: 'auto',
              px: { xs: 0, lg: 0 },
            }}
          >
            <StoryArticleBody sections={story.sections} />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          ...sectionWrapperSx,
          mt: programSectionGap,
          pb: programSectionGap,
        }}
      >
        <Box sx={{ maxWidth: 1520, mx: 'auto' }}>
          <StoryRelatedStories />
        </Box>
      </Box>
    </Box>
  )
}
